import {
  DSCV_HEADER_LOGO_CLICK,
  DSCV_MAIN_MENU_NAVIGATE_CLICK,
  DSCV_PRODUCT_BTN_CLICK,
  DSCV_GENIE_SPOTLIGHT_CTA_CLICK,
  DSCV_BLOG_ARTICLE_CLICK,
  DSCV_HERO_CAROUSEL_CTA,
  DSCV_JOIN_NEWSLETTER_CLICK,
  DSCV_FOOTER_NAVIGATE_CLICK,
  DSCV_COOKIE_CONSENT_CLICK,
  DSCV_FOOTER_SOCIAL_MEDIA_CLICK,
} from './discovery.tracking.constants';
import { track } from './tracking';

export const trackHeaderLogoClick = () => {
  track(DSCV_HEADER_LOGO_CLICK);
};

export const trackMainMenuNavigateClick = (menu_item_label) => {
  track(DSCV_MAIN_MENU_NAVIGATE_CLICK, {
    menu_item_label,
  });
};

export const trackProductButtonClick = (categoryName, productName) => {
  track(DSCV_PRODUCT_BTN_CLICK, { categoryName, productName });
};

export const trackGenieSpotlightCTAClick = () => {
  track(DSCV_GENIE_SPOTLIGHT_CTA_CLICK);
};

export const trackBlogArticleClick = (article_title) => {
  track(DSCV_BLOG_ARTICLE_CLICK, { article_title });
};

export const trackHeroCarouselCTAClick = (banner_title) => {
  track(DSCV_HERO_CAROUSEL_CTA, { banner_title });
};

export const trackJoinNewsletterClick = () => {
  track(DSCV_JOIN_NEWSLETTER_CLICK);
};

export const trackFooterNavigateClick = (menu_item_label) => {
  track(DSCV_FOOTER_NAVIGATE_CLICK, { menu_item_label });
};

// Not implemented
// export const trackCookieConsentClick = () => {
//   track(DSCV_COOKIE_CONSENT_CLICK);
// };

export const trackFooterSocialMediaClick = (menu_item_label) => {
  track(DSCV_FOOTER_SOCIAL_MEDIA_CLICK, { menu_item_label });
};
